import React, { useState } from "react";

import OverviewSection from "./OverviewSection";
import LoginStatsSection from "./LoginStatsSection";
import MobileAdoptionSection from "./MobileAdoptionSection";
import QuotaUsageSection from "./QuotaUsageSection";
import TravelUsageSection from "./TravelUsageSection";
import UnusedServicesSection from "./UnusedServicesSection";
import DataHealthSection from "./DataHealthSection";
import ReferencesSection from "./ReferencesSection";
import MigrationSection from "./MigrationSection";

const SUB_TABS = [
  { id: "overview", label: "Genel Bakış", component: OverviewSection },
  { id: "logins", label: "Giriş İstatistikleri", component: LoginStatsSection },
  { id: "mobile", label: "Mobil Kullanım", component: MobileAdoptionSection },
  { id: "quota", label: "Kota Kullanımı", component: QuotaUsageSection },
  { id: "travel", label: "Travel Kullanımı", component: TravelUsageSection },
  { id: "unused-services", label: "Kullanılmayan Servisler", component: UnusedServicesSection },
  { id: "migration", label: "Sürüm Geçişi", component: MigrationSection },
  { id: "health", label: "Veri Sağlığı", component: DataHealthSection },
  { id: "references", label: "Referans Sorgu", component: ReferencesSection },
];

const STORAGE_KEY = "admin-statistics-subtab";

const resolveInitialTab = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && SUB_TABS.some((t) => t.id === saved)) return saved;
  } catch {}
  return SUB_TABS[0].id;
};

const AdminStatistics = () => {
  const [activeTabId, setActiveTabId] = useState(resolveInitialTab);
  // Açılan sekmeler hatırlanır; böylece sekmeler arası geçişte veriler tekrar yüklenmez
  const [mountedTabs, setMountedTabs] = useState(() => new Set([resolveInitialTab()]));

  const selectTab = (tabId) => {
    setActiveTabId(tabId);
    setMountedTabs((prev) => {
      if (prev.has(tabId)) return prev;
      const next = new Set(prev);
      next.add(tabId);
      return next;
    });
    try {
      localStorage.setItem(STORAGE_KEY, tabId);
    } catch {}
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1400px", overflowY: "auto" }}>
      <h2 style={{ marginTop: 0, marginBottom: "5px" }}>İstatistikler</h2>
      <p style={{ color: "#666", fontSize: "13px", marginTop: 0, marginBottom: "20px" }}>
        Sistem geneli istatistikler. Bu sayfa veritabanında hiçbir değişiklik yapmaz, sadece okuma yapar.
      </p>

      <div
        style={{
          display: "flex",
          gap: "8px",
          flexWrap: "wrap",
          borderBottom: "1px solid #e0e0e0",
          paddingBottom: "12px",
          marginBottom: "20px",
        }}
      >
        {SUB_TABS.map((tab) => {
          const isActive = tab.id === activeTabId;
          return (
            <button
              key={tab.id}
              onClick={() => selectTab(tab.id)}
              style={{
                padding: "8px 16px",
                borderRadius: "20px",
                border: isActive ? "1px solid #1976d2" : "1px solid #ddd",
                background: isActive ? "#1976d2" : "#fff",
                color: isActive ? "#fff" : "#444",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: isActive ? 600 : 400,
                transition: "all 0.15s ease-in-out",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {SUB_TABS.map((tab) => {
        if (!mountedTabs.has(tab.id)) return null;
        const Component = tab.component;
        return (
          <div key={tab.id} style={{ display: tab.id === activeTabId ? "block" : "none" }}>
            <Component />
          </div>
        );
      })}
    </div>
  );
};

export default AdminStatistics;
